import { getInsuranceType } from '../../utils'
export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let arr = [
		{
			label: '派单公司',
			value: order.company,
		},
		{
			label: '所属险种',
			value: getInsuranceType(setting, order),
		},
		{
			label: '报案号',
			value: order.caseNo,
		},
		{
			label: '服务公司',
			value: order.serviceCompanyName,
		},
		{
			label: '订单号',
			value: order.orderNo,
		},
		{
			label: '任务类型',
			value: setting.injuredTasktypeMap[order.taskType],
		},
		{
			label: '订单类型',
			value: setting.orderTypeMap[order.orderType],
		},
	]
	// if (this.isFirstVisit || this.isResurvey) {
	// 	arr.push({
	// 		label: '订单类型',
	// 		value: setting.orderTypeMap[order.orderType],
	// 	})
	// }
	if (this.isMotion) {
		arr.push({
			label: '伤者所在地',
			value: setting.injuredLocationMap[order.locationType],
		})
	}
	if (this.isFirstVisit || (this.isResurvey && this.isCarInsurance)) {
		arr = arr.concat([
			{
				label: '车主/报案人姓名',
				value: order.ownerName,
			},
			{
				label: '车主/报案人电话',
				value: order.ownerPhone,
			},
		])
	}
	if (this.isCarInsurance && (this.isFirstVisit || this.isResurvey)) {
		arr.push({
			label: '标的车牌号',
			value: order.carNo,
		})
	}
	arr.push({
		label: '伤者姓名',
		value: order.injuredName,
	})
	if (order.injuredPhone) {
		const phone = order.injuredPhone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '伤者电话',
				value: phone[0],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `伤者电话${index + 1}`,
					value: item,
				})
			}
		}
	} else {
		arr.push({
			label: '伤者电话',
			value: order.injuredPhone,
		})
	}
	arr.push({
		label: '任务要求',
		value: order.visitRequest,
	})
	if (this.isMotionAtHome) {
		arr = arr.concat([
			{
				label: '伤者居住所在区域',
				value: order.clinicArea,
			},
			{
				label: '伤者居住地详细地址',
				value: order.hospital,
			},
		])
	} else if (this.isHomeInvestigate) {
		arr = arr.concat([
			{
				label: '伤者居住所在区域',
				value: order.clinicArea,
			},
			{
				label: '伤者居住地详细地址',
				value: order.address,
			},
		])
	} else {
		arr = arr.concat([
			{
				label: '就诊地区',
				value: order.clinicArea,
			},
			{
				label: '就诊医院',
				value: order.hospital,
			},
		])
	}
	if (!this.isMotionAtHome && !this.isHomeInvestigate) {
		arr.push({
			label: '所在科室',
			value: order.department,
		})
	}
	arr = arr.concat([
		{
			label: '案件负责人姓名',
			value: order.contact,
		},
		{
			label: '案件负责人电话',
			value: order.contactPhone,
		},
	])
	if (this.isMotion) {
		arr.push({
			label: '关节活动度复勘部位',
			value: order.injuryPositions
				.split(',')
				.map(item => {
					return setting.activityPositionMap[item]
				})
				.join('、'),
		})
	}

	if (order.cancelReason) {
		arr.push({
			label: '撤单原因',
			value: order.cancelReason,
		})
	}
	return {
		title: '任务信息',
		children: arr,
	}
}
